export  enum EPage{
    login,
    clients,
    courier,
    openOrder,
    orders,
    orderHistory

}
